<template>
    <div class="toggle" :class="{disabled}">
        <input
            type="checkbox"
            :name="name"
            value="true"
            :disabled="disabled"
            :checked="value"
            :id="id"
            @input="$emit('input', $event.target.checked)"
            @change="$emit('change', $event.target.checked)"
        >

        <label :for="id" class="toggle-wrapper">
            <span class="toggle-container">
                <span class="toggle-text" v-if="$slots['text-off']">
                    <slot name="text-off"></slot>
                </span>

                <span class="toggle-text" v-if="!$slots['text-off']">
                    <slot name="text">&nbsp;</slot>
                </span>

                <span class="toggle-text-checked" v-if="$slots['text-on']">
                    <slot name="text-on"></slot>
                </span>

                <span class="toggle-text-checked" v-if="!$slots['text-on']">
                    <slot name="text"></slot>
                </span>
            </span>

            <span class="toggle-knob elevate">
                <slot name="knob"></slot>
            </span>
        </label>
        <label :for="id" v-if="$slots['default']" class="toggle-label">
            <slot></slot>
        </label>
    </div>
</template>

<script>
    export default {
        props: ['value', 'check', 'name', 'disabled'],

        computed: {
            time () {
                return new Date().getTime();
            },

            id () {
                if (this.name) return 'toggle-' + this.name;
                return 'toggle-' + this.time;
            }
        }
    }
</script>

<style scoped lang="postcss">
.toggle {
    user-select: none;

    display:     flex;
    align-items: flex-start;

    input[type="checkbox"] {
        /* clip: rect(0 0 0 0); */

        /* margin:  -1px; */
        border:  0;
        padding: 0;

        width:  0px;
        height: 0px;

        position: absolute;
        overflow: hidden;
        visibility: hidden;

        ~ label {
            cursor: pointer;
        }
    }

    &.disabled input[type="checkbox"] ~ label {
        cursor: not-allowed !important;
    }
}

.toggle-wrapper {
    color:       var(--color-cases-gray-0);
    font-size:   12px;
    line-height: 1.33334;

    display: block;

    position: relative;
}

.toggle-container {
    background-color: var(--color-cases-gray-5);
    transition:       background-color .15s ease;

    border-radius: 99999px;
    padding:       8px 8px 8px 36px;

    display:   block;
    min-width: 60px;
    min-height: 32px;

    position: relative;
    overflow: hidden;
}

.toggle-text,
.toggle-text-checked {
    transition: opacity .125s ease;
}

.toggle-text {
    opacity: 1;

    display:   block;
    min-width: 16px;

    position: relative;
    left:     0;

    input[type="checkbox"]:checked + label & {
        opacity: 0;
    }
}

.toggle-text-checked {
    opacity: 0;

    display: block;

    position: absolute;
    top:      8px;
    left:     8px;

    input[type="checkbox"]:checked + label & {
        opacity: 1;
    }
}

.toggle-knob {
    color:       var(--color-cases-gray-2);
    font-size:   22px;
    line-height: 1.09091;
    text-align:  center;

    box-shadow: 0 1px 3px var(--color-shadow);
    transition: left .15s ease, color .15s ease;

    border-radius: 99999px;
    padding:       4px;

    display: block;
    width:   32px;
    height:  32px;

    position: absolute;
    top:      0;
    left:     0;

    [class^="icon-"],
    [class*=" icon-"] {
        line-height: inherit;

        display: block;
    }

    input[type="checkbox"]:checked + label & {
        color: var(--color-cases-red);
        left: calc(100% - 31px);
    }
}

.toggle-label {
    margin-left: 8px;
}


.default {
    input[type="checkbox"]:checked + .toggle-wrapper .toggle-container {
        background-color: var(--color-cases-green);
    }
}

.regular {
    .toggle-wrapper {margin: 2px 0;}

    .toggle-container {
        min-width: 32px;
        min-height: 20px;
        padding: 0;
        background-color: var(--color-cases-gray-3);
    }

    .toggle-knob {
        width: 20px;
        height: 20px;
    }

    input[type="checkbox"]:checked + label .toggle-knob {
        left: calc(100% - 20px);
    }

    input[type="checkbox"]:checked + .toggle-wrapper .toggle-container {
        background-color: var(--color-cases-blue);
    }
}
</style>
